/**
 * Event ID helpers to avoid scattering `?? ''` / `?? null` for event identifiers.
 * Use for display/labels and non-critical comparisons; validate required ids at call sites.
 */

type EventLike = { event_id?: number | string } | null | undefined;

/**
 * Returns a string suitable for display, React keys, or comparison when the id may be missing.
 * Centralises the "optional event id" pattern so we don't hide missing data with arbitrary fallbacks elsewhere.
 */
export function getEventIdForDisplay(record: EventLike): string {
  const id = record?.event_id;
  return id != null ? String(id) : '';
}

/**
 * Same as getEventIdForDisplay but for a raw id value (e.g. countdownData.eventId, error labels).
 * Use for i18n/display only; keeps a single documented fallback for labels.
 */
export function safeEventIdForLabel(id: number | string | null | undefined): string {
  return id != null ? String(id) : '';
}
